import type { ApolloFieldName } from "./apollo-field-library";

export interface CustomFormConfig {
	app_id?: string;
	scheduling_link: string;
	form_id: string;
	title: string;
	description: string;
	fields: readonly ApolloFieldName[];
	required_fields: readonly ApolloFieldName[];
	field_labels?: Partial<Record<ApolloFieldName, string>>;
	success_message: string;
}

const custom_form_configs = {
	"b1000-book-a-demo": {
		app_id: "69cbcdc59de433002106d624",
		scheduling_link: "e5h-41l-f9y",
		form_id: "b1000-book-a-demo",
		title: "Get started with StudyStash",
		description: "Schedule a 15-minute demo with our team",
		fields: ["full_name", "job_title", "email", "org_name"],
		required_fields: ["full_name", "job_title", "email", "org_name"],
		success_message: "Thanks! Your request has been sent. We'll be in touch shortly.",
	},
	"d1000-download-ai-in-higher-education": {
		scheduling_link: "kre-m7u-zp6",
		form_id: "d1000-download-ai-in-higher-education",
		title: "Download the article",
		description: "Authored by Joanna Williams, Senior Marketing Executive at StudyStash",
		fields: ["full_name", "job_title", "email", "phone", "org_name", "pilot_interest"],
		required_fields: ["full_name", "job_title", "email", "org_name"],
		success_message: "Thanks! Your request has been sent. We'll be in touch shortly.",
	},
	"d1001-download-the-business-influencer": {
		scheduling_link: "b0d-065-qzk",
		form_id: "d1001-download-the-business-influencer",
		title: "Download the article",
		description: "Authored by Ben Ward, Chief Executive Officer at StudyStash",
		fields: ["full_name", "job_title", "email", "phone", "org_name", "pilot_interest"],
		required_fields: ["full_name", "job_title", "email", "org_name"],
		success_message: "Thanks! Your request has been sent. We'll be in touch shortly.",
	},
	"d1002-download-build-or-buy": {
		scheduling_link: "93v-j19-9xi",
		form_id: "d1002-download-build-or-buy",
		title: "Read our latest Perspective Piece",
		description:
			'The StudyStash Perspective Piece "Build or Buy: The Debate" explores the current conversation around AI-powered learning tools, alongside the challenges and opportunities associated.',
		fields: ["full_name", "email", "org_name", "job_title", "pilot_interest"],
		required_fields: ["full_name", "email", "org_name", "job_title"],
		field_labels: {
			org_name: "University/College",
		},
		success_message: "Thanks! Your request has been sent. We'll be in touch shortly.",
	},
	"d1003-download-integrations-guide": {
		scheduling_link: "4xi-2k1-j7a",
		form_id: "d1003-download-integrations-guide",
		title: "Request our LTI integration guide",
		description: "You can find more on https://trust.studystash.com/",
		fields: ["full_name", "job_title", "email", "org_name", "pilot_interest"],
		required_fields: ["full_name", "job_title", "email", "org_name"],
		success_message: "Thanks! Your request has been sent. We'll be in touch shortly.",
	},
	"d1004-download-neuroscience-perspective": {
		scheduling_link: "84j-kso-m3i",
		form_id: "d1004-download-neuroscience-perspective",
		title: "Download our Neuroscience Perspective",
		description: "Authored by Milad Ekramnia, CEO of EdCortex",
		fields: ["full_name", "job_title", "email", "org_name", "pilot_interest"],
		required_fields: ["full_name", "job_title", "email", "org_name"],
		success_message: "Thanks! Your request has been sent. We'll be in touch shortly.",
	},
	"d1005-download-brochure-uk": {
		scheduling_link: "pyo-h4u-462",
		form_id: "d1005-download-brochure-uk",
		title: "Download the brochure",
		description: "Close your teaching-learning loop today",
		fields: ["full_name", "job_title", "email", "org_name", "pilot_interest"],
		required_fields: ["full_name", "job_title", "email", "org_name"],
		success_message: "Thanks! Your request has been sent. We'll be in touch shortly.",
	},
	"d1006-download-jcc-evaluation": {
		scheduling_link: "a18-yal-g7f",
		form_id: "d1006-download-jcc-evaluation",
		title: "Download the evaluation paper",
		description:
			"Co-led by Trina Tiernan, Learning and Employability Manager at Joseph Chamberlain College and StudyStash.",
		fields: ["full_name", "job_title", "email", "org_name", "pilot_interest"],
		required_fields: ["full_name", "job_title", "email", "org_name"],
		success_message: "Thanks! Your request has been sent. We'll be in touch shortly.",
	},
	"e1000-uob-evaluation-paper": {
		scheduling_link: "oqx-ych-pyc",
		form_id: "e1000-uob-evaluation-paper",
		title: "Download the evaluation paper",
		description:
			"Led by Tom Harrison, Deputy Pro-Vice-Chancellor of Education Innovation at the University of Birmingham",
		fields: ["full_name", "job_title", "email", "org_name", "pilot_interest"],
		required_fields: ["full_name", "job_title", "email", "org_name"],
		success_message: "Thanks! Your request has been sent. We'll be in touch shortly.",
	},
	"e1002-eab-evaluation-paper-usa": {
		scheduling_link: "u9w-x5g-8n2",
		form_id: "e1002-eab-evaluation-paper-usa",
		title: "Download the evaluation paper",
		description:
			"Created by Abhi Panthagani, Associate Director of Strategic Research and Antoinette Waller, Research Analyst at EAB",
		fields: ["full_name", "job_title", "email", "phone", "org_name", "pilot_interest"],
		required_fields: ["full_name", "job_title", "email", "org_name"],
		success_message: "Thanks! Your request has been sent. We'll be in touch shortly.",
	},
	"p1001-interested-in-pilot": {
		scheduling_link: "chs-lzn-92y",
		form_id: "p1001-interested-in-pilot",
		title: "Ready to close your Teaching and Learning loop?",
		description: "Join our pilot program today and be at the forefront of AI-enhanced education",
		fields: ["full_name", "job_title", "email", "org_name"],
		required_fields: ["full_name", "job_title", "email", "org_name"],
		success_message: "Thanks! Your request has been sent. We'll be in touch shortly to schedule your pilot call.",
	},
	"p1002-interested-in-pilot-colleges": {
		scheduling_link: "chs-lzn-92y",
		form_id: "p1002-interested-in-pilot-colleges",
		title: "Ready to close your Teaching and Learning loop?",
		description:
			"Join our Pilot Program today and be one of the five colleges to support your students and teachers with AI-enhanced study and revision tools",
		fields: ["full_name", "job_title", "email", "org_name"],
		required_fields: ["full_name", "job_title", "email", "org_name"],
		success_message: "Thanks! Your request has been sent. We'll be in touch shortly to schedule your pilot call.",
	},
	"p1003-interested-in-pilot-educause25": {
		scheduling_link: "chs-lzn-92y",
		form_id: "p1003-interested-in-pilot-educause25",
		title: "Ready to close your Teaching and Learning loop?",
		description: "Join our EDUCAUSE25 pilot program today and be at the forefront of AI-enhanced education",
		fields: ["full_name", "job_title", "email", "phone", "org_name"],
		required_fields: ["full_name", "job_title", "email", "org_name"],
		success_message: "Thanks! Your request has been sent. We'll be in touch shortly to schedule your pilot call.",
	},
	"p1004-interested-in-pilot-eab-connected25": {
		scheduling_link: "chs-lzn-92y",
		form_id: "p1004-interested-in-pilot-eab-connected25",
		title: "Ready to close your Teaching and Learning loop?",
		description: "Join our EAB CONNECTED25 pilot program today and be at the forefront of AI-enhanced education",
		fields: ["full_name", "job_title", "email", "phone", "org_name"],
		required_fields: ["full_name", "job_title", "email", "org_name"],
		success_message: "Thanks! Your request has been sent. We'll be in touch shortly to schedule your pilot call.",
	},
	"p1005-interested-in-pilot-jisc": {
		scheduling_link: "chs-lzn-92y",
		form_id: "p1005-interested-in-pilot-jisc",
		title: "Ready to close your Teaching and Learning loop?",
		description: "Join our Digifest 2026 exhibition pilot program today and be at the forefront of AI-enhanced education",
		fields: ["full_name", "job_title", "email", "phone", "org_name"],
		required_fields: ["full_name", "job_title", "email", "org_name"],
		success_message: "Thanks! Your request has been sent. We'll be in touch shortly to schedule your pilot call.",
	},
	"w1000-waitlist-students": {
		scheduling_link: "w94-tk8-3xp",
		form_id: "w1000-waitlist-students",
		title: "Join the student waitlist",
		description: "We are launching our student version of StudyStash soon!",
		fields: ["full_name", "email", "phone"],
		required_fields: ["full_name", "email", "phone"],
		field_labels: {
			email: "Student/Personal Email",
		},
		success_message: "Thanks! You've been added to the waitlist.",
	},
	"w1001-waitlist-training-providers": {
		scheduling_link: "e5h-41l-f9y",
		form_id: "w1001-waitlist-training-providers",
		title: "Interested in hearing more?",
		description: "We work with bootcamp and training providers that want to deliver high quality courses at scale",
		fields: ["full_name", "email", "org_name", "phone"],
		required_fields: ["full_name", "email", "org_name", "phone"],
		field_labels: {
			email: "Work Email",
			org_name: "Company name",
		},
		success_message: "Thanks! Your request has been sent. We'll be in touch shortly.",
	},
} satisfies Record<string, CustomFormConfig>;

export type CustomFormId = keyof typeof custom_form_configs;
export const CUSTOM_FORM_CONFIGS: Record<CustomFormId, CustomFormConfig> = custom_form_configs;
